import { render, staticRenderFns } from "./DemoStepsForm.vue?vue&type=template&id=881481fe"
import script from "./DemoStepsForm.vue?vue&type=script&lang=js"
export * from "./DemoStepsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports